export default "__VITE_ASSET__BUvdHztx__"